// extracted by css-extract-rspack-plugin
export default {"noBorderRadius":"FlexSuiteOutroCTA-module__noBorderRadius__L5i0w"};